/** This class is used for extension and shouldnot be used for storing website */
class LocalStorage {
    static setUserData(data) {
        const userData = localStorage.getItem('userExtData');
        if (userData) {
            const localData = JSON.parse(userData);
            if (localData) {
                localStorage.setItem('userExtData', JSON.stringify({ ...localData, data }));
            }
        } else {
            if (data) {
                localStorage.setItem('userExtData', JSON.stringify(data));
            }
        }
    }

    static getUserData() {
        return this.parseJsonData('userExtData');
    }

    static setAuthToken(token) {
        localStorage.setItem('diologExtAuthToken', token);
    }

    static getAuthToken() {
        return localStorage.getItem('diologExtAuthToken');
    }

    static setSelectedCompany(company) {
        return localStorage.setItem('selectedExtCompany', JSON.stringify(company));
    }

    static getSelectedCompany() {
        return this.parseJsonData('selectedExtCompany');
    }

    static getIntroSetup() {
        return localStorage.getItem('introSetup');
    }

    static setIntroSetup() {
        localStorage.setItem('introSetup', true);
    }

    static getUserType() {
        return localStorage.getItem('isNotFromOrganization', true);
    }

    static setUserType() {
        localStorage.setItem('isNotFromOrganization', true);
    }

    static remove(keys) {
        for (let i of keys) {
            localStorage.removeItem(i);
        }
    }

    static parseJsonData(key) {
        const data = localStorage.getItem(key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    static setUserEmail(value) {
        localStorage.setItem('diologExtEmail', value);
    }

    static getUserEmail() {
        return localStorage.getItem('diologExtEmail');
    }
}

export default LocalStorage;
